import { gql } from "apollo-boost";


export const GET_UNITS = gql`
query Units($where: UnitWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    units(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        shop {
          name
        }
        id
        detail
        name
        updatedBy {
          username
        }
        updatedAt
        isDeleted
        createdBy {
          username
        }
        createdAt
      }
    }
  }

`

export const GET_SUVIVALS = gql`
query Survivals($where: SurvivalWhereInput) {
  survivals(where: $where) {
    total
    data {
      id
      survivalNumber
      status
      note
      isDeleted
      createdAt
      updatedAt
    }
  }
}
`